import { Typography } from "@mui/material";
import React from "react";

const AdditionalSkills = ({ data }) => {
  return (
    <ul id="Additional Skills">
      {data.map((item) => (
        <li key={item}>
          <Typography variant="body3">{item}</Typography>
        </li>
      ))}
    </ul>
  );
};

export default AdditionalSkills;
